import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { AuditTrailViewModel } from '@services/cleanfill-api/cleanfill-api.generated';

@Component({
  selector: 'app-esvr-audit-trails',
  templateUrl: './esvr-audit-trails.component.html',
  styleUrls: ['./esvr-audit-trails.component.scss'],
})
export class EsvrAuditTrailsComponent implements OnInit, OnChanges {
  @Input() auditTrails: AuditTrailViewModel[];

  displayedColumns: string[] = ['modifiedDate', 'modifiedBy', 'changes'];

  displayedChangesColumns: string[] = ['propertyName', 'oldValue', 'newValue'];

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges() {
    if (this.auditTrails?.length > 0) {
      for (const item of this.auditTrails) {
        if (item[`changes`]?.length > 0) {
          for (const changeItem of item[`changes`] ) {
            if (changeItem[`propertyName`] &&
                (changeItem[`propertyName`] === 'Outbound' || changeItem[`propertyName`] === 'TransferDate')) {
              changeItem[`newValue`] = new Date(changeItem[`newValue`]);
              if (changeItem[`oldValue`]) changeItem[`oldValue`] = new Date(changeItem[`oldValue`]);
            }
          }
        }
      }
    }
  }
}
